import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, MessageCircle, Check } from "lucide-react";
import { useI18n } from "../../lib/i18n";
import { whatsappLink } from "../../lib/whatsapp";

export const CTASection = () => {
  const { t, locale } = useI18n();
  const isDE = locale === "de";
  const trust = isDE
    ? ["Kostenloses Erstgespräch", "Keine Verpflichtung", "Antwort innerhalb von 24 Stunden", "Agentur aus Berlin"]
    : ["Free consultation", "No obligation", "Response within 24 hours", "Berlin-based agency"];
  const waMsg = isDE
    ? "Hallo Joshi FusionTech Media, ich möchte mehr über eure Leistungen erfahren."
    : "Hi Joshi FusionTech Media, I'd like to learn more about your services.";
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24">
      <div className="relative glass-strong rounded-3xl p-10 md:p-14 lg:p-16 overflow-hidden">
        <div className="absolute inset-0 neural-glow opacity-80" />
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-brand-azure/20 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-brand-orange/15 blur-3xl" />
        <div className="relative z-10 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-center">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-12 h-px bg-brand-orange" />
              <span className="label-mono">{isDE ? "Bereit zu starten?" : "Ready to start?"}</span>
            </div>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-tighter text-white">
              {t.cta.title}
            </h2>
            <p className="mt-6 text-white/65 text-base md:text-lg max-w-xl leading-relaxed">{t.cta.subtitle}</p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-2.5 text-sm">
              {trust.map((tt, i) => (
                <li key={i} className="flex items-center gap-2 text-white/75" data-testid={`cta-trust-${i}`}>
                  <span className="w-5 h-5 rounded-full bg-brand-orange/15 border border-brand-orange/40 flex items-center justify-center">
                    <Check className="w-3 h-3 text-brand-orange" />
                  </span>
                  {tt}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <Link to="/book" data-testid="cta-primary" className="btn-primary group !justify-center">
              <Calendar className="w-4 h-4" />
              {isDE ? "Kostenloses Strategiegespräch" : "Book free strategy call"}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <a
              href={whatsappLink(waMsg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp"
              className="btn-secondary !justify-center !border-[#25D366]/40 hover:!border-[#25D366]"
            >
              <MessageCircle className="w-4 h-4 text-[#25D366]" />
              WhatsApp Business
            </a>
            <Link to="/contact" data-testid="cta-contact" className="btn-ghost !justify-center">
              {isDE ? "Kontaktformular" : "Contact form"}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
